<template>
  <v-tooltip :location="location" :max-width="maxWidth" :open-delay="openDelay" :content-class="contentClass">
    <template v-slot:activator="{ props }">
      <slot name="activator" :props="props" />
    </template>
    <slot>{{ text }}</slot>
  </v-tooltip>
</template>

<script>
/**
 * Single wrapper around Vuetify's v-tooltip so every tooltip in the app
 * shares the same defaults (position, sizing, open delay) - change them
 * here once instead of in every view that shows a hint.
 *
 * Usage:
 *   <AppTooltip text="Some hint">
 *     <template v-slot:activator="{ props }">
 *       <v-icon v-bind="props">mdi-information-outline</v-icon>
 *     </template>
 *   </AppTooltip>
 *
 * For the common "small icon with a text hint" case, prefer IconTooltip
 * instead of using this directly.
 */
export default {
  name: 'AppTooltip',

  props: {
    text: {
      type: String,
      default: ''
    },
    location: {
      type: String,
      default: 'top'
    },
    maxWidth: {
      type: [String, Number],
      default: 320
    },
    openDelay: {
      type: [String, Number],
      default: 200
    },
    contentClass: {
      type: String,
      default: undefined
    }
  }
};
</script>
